export default __webpack_public_path__ + "images/favicon/6 АВТОРСКИЙ_.jpg";